import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteKeyLockerMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async keylocker_id => {
      await ApiInstance.post("/dashboard/delete", { keylocker_id }, ENV.keylockerBaseURL);
    },
    onSuccess: keylocker_id => {
      const keyLockers = typedQueryClient.getQueryData(KeyLockersQueryKeys.keyLockers);
      if (!keyLockers) return;

      const keyLockerIdx = keyLockers.findIndex(keyLocker => keyLocker.id === keylocker_id);
      if (keyLockerIdx === -1) return;

      typedQueryClient.setQueryData(KeyLockersQueryKeys.keyLockers, keyLockers.toSpliced(keyLockerIdx, 1));
    }
  });
